import './../css/Header.css';
import {  Link  } from "react-router-dom";

function CrmHeader() {

    return (
        <div className="Header">

            <div className="header">Header</div>
                <Link to="/product-list">список товарів</Link>-       -
            {/*<Link to="/product-create">додати товар</Link>*/}
        </div>

    );
}

export default CrmHeader;
